module.exports = __webpack_public_path__ + "img/product_xd_ng_4.41033220.jpg";